var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconContactFormF8Pdau4Jks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#35216D;}\r\n\t.st1{fill:#EDF3FC;}\r\n\t.st2{fill:#330D84;}\r\n\t.st3{fill:#FFBE1B;}\r\n\t.st4{fill:#0061F3;}\r\n\t.st5{fill:#8C7BFD;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:#5932AE;}\r\n\t.st8{fill:#1C46C4;}\r\n\t.st9{fill:#6857E5;}\r\n\t.st10{fill:#5D8EF9;}\r\n\t.st11{fill:#8AC9F9;}\r\n\t.st12{fill:#FFE37B;}\r\n\t.st13{fill:#FFD000;}\r\n\t.st14{fill:#2EF39E;}\r\n\t.st15{fill:#330D84;stroke:#330D84;stroke-width:0.6306;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st16{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.737;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st17{fill:none;}\r\n\t.st18{fill:#FDB813;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.999,40.928c-118.778,0-215.071,96.294-215.071,215.074c0,118.776,96.292,215.068,215.071,215.068 S471.07,374.778,471.07,256.002C471.07,137.222,374.777,40.928,255.999,40.928z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.999,1C115.391,1,1,115.392,1,256.002C1,396.609,115.391,511,255.999,511S511,396.609,511,256.002 C511,115.392,396.607,1,255.999,1z M255.999,502.832c-136.103,0-246.83-110.728-246.83-246.83 c0-136.104,110.727-246.833,246.83-246.833c136.102,0,246.832,110.729,246.832,246.833 C502.831,392.104,392.101,502.832,255.999,502.832z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M266.903,412.863l2.875,0.72l-2.875,0.72c-16.833,4.218-29.97,17.359-34.186,34.192l-0.724,2.871 l-0.721-2.871c-4.217-16.833-17.357-29.974-34.195-34.192l-2.864-0.72l2.864-0.72c16.838-4.218,29.978-17.363,34.195-34.186 l0.721-2.869l0.724,2.869C236.933,395.5,250.07,408.645,266.903,412.863L266.903,412.863z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269.956,103.231l2.322,0.582l-2.322,0.582c-13.598,3.407-24.21,14.023-27.616,27.62l-0.585,2.32l-0.583-2.32 c-3.406-13.598-14.021-24.213-27.622-27.62l-2.314-0.582l2.314-0.582c13.602-3.407,24.216-14.026,27.622-27.616l0.583-2.318 l0.585,2.318C245.746,89.205,256.358,99.824,269.956,103.231L269.956,103.231z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112.332,206.604l1.668,0.418l-1.668,0.418c-9.768,2.447-17.39,10.073-19.837,19.84l-0.42,1.666l-0.419-1.666 c-2.447-9.768-10.071-17.393-19.842-19.84l-1.662-0.418l1.662-0.418c9.77-2.447,17.395-10.075,19.842-19.837l0.419-1.665 l0.42,1.665C94.941,196.529,102.564,204.156,112.332,206.604L112.332,206.604z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.717,117.928l1.648,0.413l-1.648,0.413c-9.649,2.418-17.18,9.951-19.597,19.6L301.706,140l-0.413-1.646 c-2.417-9.649-9.949-17.182-19.602-19.6l-1.642-0.413l1.642-0.413c9.652-2.418,17.184-9.953,19.602-19.597l0.413-1.645l0.415,1.645 C304.537,107.975,312.068,115.51,321.717,117.928L321.717,117.928z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M167.842,392.661l1.484,0.372l-1.484,0.372c-8.686,2.176-15.465,8.957-17.64,17.643l-0.373,1.482 l-0.372-1.482c-2.176-8.686-8.956-15.467-17.645-17.643l-1.478-0.372l1.478-0.372c8.688-2.176,15.469-8.959,17.645-17.64 l0.372-1.48l0.373,1.48C152.377,383.702,159.156,390.484,167.842,392.661L167.842,392.661z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M365.738,360.045H146.267c-13.893,0-25.155-11.261-25.155-25.152V177.104 c0-13.887,11.263-25.148,25.155-25.148h219.472c13.891,0,25.15,11.262,25.15,25.148v157.789 C390.889,348.784,379.629,360.045,365.738,360.045L365.738,360.045z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 300.422,
    cy: 173.584,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 330.866,
    cy: 173.584,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M368.809,173.584c0,4.143-3.356,7.5-7.501,7.5c-4.142,0-7.499-3.357-7.499-7.5s3.358-7.5,7.499-7.5 C365.452,166.084,368.809,169.441,368.809,173.584z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M365.738,360.045H146.267c-13.893,0-25.155-11.261-25.155-25.152V196.602h269.777v138.291 C390.889,348.784,379.629,360.045,365.738,360.045L365.738,360.045z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.386,229.587h-59.995c-2.761,0-5-2.238-5-5s2.239-5,5-5h59.995c2.761,0,5,2.238,5,5 S211.147,229.587,208.386,229.587z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.947,
    y: 213.587,
    className: "st11",
    width: 127.662,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.386,265.587h-59.995c-2.761,0-5-2.238-5-5s2.239-5,5-5h59.995c2.761,0,5,2.238,5,5 S211.147,265.587,208.386,265.587z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.947,
    y: 249.587,
    className: "st11",
    width: 127.662,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.386,301.587h-59.995c-2.761,0-5-2.238-5-5s2.239-5,5-5h59.995c2.761,0,5,2.238,5,5 S211.147,301.587,208.386,301.587z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.947,
    y: 285.587,
    className: "st11",
    width: 127.662,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.922,
    y: 321.587,
    className: "st3",
    width: 61,
    height: 21.081
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconContactFormF8Pdau4Jks);
export default __webpack_public_path__ + "static/media/reshot-icon-contact-form-F8PDAU4JKS.730df43f6531321b2900bbb3512aa49e.svg";
export { ForwardRef as ReactComponent };